import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import { assignTestId } from '@app/common/infra/tests/assign-test-id';
import styles from './toolbar-item.css';
export default function ToolbarItem(props) {
    const { label, children, ...rest } = props;
    return (_jsxs("div", { className: styles.toolbarItem, ...assignTestId('toolbar-item', rest), children: [_jsx(Text, { info: true, className: styles.toolbarItemLabel, ...assignTestId('toolbar-item-label'), children: label }), children] }));
}
